import { render, staticRenderFns } from "./QCSensors.vue?vue&type=template&id=a60dbe76"
import script from "./QCSensors.vue?vue&type=script&lang=js"
export * from "./QCSensors.vue?vue&type=script&lang=js"
import style0 from "./QCSensors.vue?vue&type=style&index=0&id=a60dbe76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports